<template>
  <div>
    <v-row dense class="match-height">
      <v-col cols="auto">
        <v-card
          class="d-flex flex-column align-end pa-2"
          outlined
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
        >
          <div class="d-flex flex-column align-center">
            <v-icon
              :color="trafficLightStatus === 'red' ? 'error' : 'grey'"
              :class="[
                'traffic-light-icon traffic-light-icon-1',
                {
                  'traffic-light-active': trafficLightStatus === 'red',
                },
              ]"
              size="20"
              >mdi-circle</v-icon
            >
            <v-icon
              :color="trafficLightStatus === 'yellow' ? 'orange' : 'grey'"
              :class="[
                'my-1 traffic-light-icon traffic-light-icon-2',
                { 'traffic-light-active': trafficLightStatus === 'yellow' },
              ]"
              size="20"
              >mdi-circle</v-icon
            >

            <v-icon
              :color="trafficLightStatus === 'green' ? 'success' : 'grey'"
              :class="[
                'traffic-light-icon traffic-light-icon-3',
                {
                  'traffic-light-active': trafficLightStatus === 'green',
                },
              ]"
              size="20"
              >mdi-circle</v-icon
            >
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined>
          <v-list-item class="px-2" dense>
            <v-list-item-avatar
              :color="trafficLightStatusDisplay.colorLighten"
              size="25"
            >
              <v-icon :color="trafficLightStatusDisplay.colorDarken" small>
                mdi-traffic-light
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ trafficLightStatusText }}
              </v-list-item-title>
              <!-- <v-list-item-subtitle>Status (Gesamt)</v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item class="px-2" dense>
            <v-list-item-avatar
              :color="totalStatusDisplay.colorLighten"
              size="25"
            >
              <v-icon :color="totalStatusDisplay.colorDarken" small>
                {{ totalStatusDisplay.icon }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                totalStatusDisplay.text
              }}</v-list-item-title>
              <!-- <v-list-item-subtitle>Status (Gesamt)</v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "performance-target-personal-result-view",
  components: {},
  props: {
    totalStatus: {
      type: String,
      required: true,
      default: "unknown",
    },
    trafficLightStatus: {
      type: String,
      required: false,
      default: "unknown",
    },
  },
  computed: {
    trafficLightStatusText() {
      const status = this.trafficLightStatus;
      switch (status) {
        case "green":
          return "Grüne Ampel";
        case "yellow":
          return "Gelbe Ampel";
        case "red":
          return "Rote Ampel";
        default:
          return "Unbekannt";
      }
    },
    trafficLightStatusDisplay() {
      const status = this.trafficLightStatus;
      switch (status) {
        case "green":
          return {
            colorDarken: "green darken-2",
            colorLighten: "green lighten-4",
          };
        case "yellow":
          return {
            colorDarken: "orange darken-2",
            colorLighten: "orange lighten-4",
          };
        case "red":
          return {
            colorDarken: "red darken-2",
            colorLighten: "red lighten-4",
          };
        default:
          return {
            colorDarken: "grey darken-2",
            colorLighten: "grey lighten-4",
          };
      }
    },
    formattedCutOffDate() {
      if (!this.nextCutOffDate) {
        return "";
      }

      // Handle Firestore Timestamp
      const date = this.nextCutOffDate.toDate
        ? this.nextCutOffDate.toDate()
        : new Date(this.nextCutOffDate);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },
    totalStatusDisplay() {
      const status = this.totalStatus;
      switch (status) {
        case "green":
        case "met":
        case "metByIndividualRuling":
          return {
            text: "Alle erfüllt",
            icon: "mdi-check-circle",
            colorDarken: "green darken-2",
            colorLighten: "green lighten-4",
          };
        case "yellow":
          return {
            text: "Teilweise erfüllt",
            icon: "mdi-alert",
            colorDarken: "orange darken-2",
            colorLighten: "orange lighten-4",
          };
        case "red":
        case "notMet":
          return {
            text: "Nicht erfüllt",
            icon: "mdi-close",
            colorDarken: "red darken-2",
            colorLighten: "red lighten-4",
          };
        case "notApplicable":
          return {
            text: "Nicht anwendbar",
            icon: "mdi-help",
            colorDarken: "purple darken-2",
            colorLighten: "purple lighten-4",
          };
        case "unknown":
        default:
          return {
            text: "Unbekannt",
            icon: "mdi-help",
            colorDarken: "grey darken-2",
            colorLighten: "grey lighten-4",
          };
      }
    },
  },
  methods: {},
};
</script>

<style scoped>
/* Traffic light intro animation */
.traffic-light-icon {
  animation: lightUp 0.6s ease-out forwards;
  opacity: 0;
  transform: scale(0.3);
}

.traffic-light-icon-1 {
  animation-delay: 0.1s;
}

.traffic-light-icon-2 {
  animation-delay: 0.25s;
}

.traffic-light-icon-3 {
  animation-delay: 0.4s;
}

@keyframes lightUp {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Pulse animation for active status only */
.traffic-light-active {
  animation-delay: 0.4s;
  animation: lightUp 0.6s ease-out forwards, pulse 2s ease-in-out 0.8s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
